import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './loader-overlay.scss';
import theme from '../../theme';
import { Grid, GridItem, Text } from '@chakra-ui/react';
import { SpinnerLarge } from '@codametrix/verdigris';
const LoadingOverlay = (props)=>{
    const { loadingMsg } = props;
    return /*#__PURE__*/ _jsx(Grid, {
        display: "table",
        justifyContent: "center",
        className: "loader-wrapper",
        children: /*#__PURE__*/ _jsxs(Grid, {
            gridGap: 0,
            className: "loading-indicator",
            children: [
                /*#__PURE__*/ _jsx(GridItem, {
                    className: "loading-indicator-inner",
                    children: /*#__PURE__*/ _jsx(SpinnerLarge, {
                        titleText: "In progress"
                    })
                }),
                loadingMsg && /*#__PURE__*/ _jsx(GridItem, {
                    className: "loading-indicator-inner",
                    children: /*#__PURE__*/ _jsx(Text, {
                        color: theme.colors.text['highEmphasis'],
                        textStyle: theme.textStyles['h1'],
                        className: "text",
                        children: loadingMsg
                    })
                })
            ]
        })
    });
};
export default LoadingOverlay;
